import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import { SpeakerNotes } from 'material-ui-icons'
import Menu, { MenuItem } from 'material-ui/Menu';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment'

import * as userdetails from '../../../actions/userdetails';

class CardMenu extends React.Component {
    render() {
        const ITEM_HEIGHT = 40;
        const options =
            [
                { id: 1, name: 'View' }
            ];
        const { menuState, anchorEl, handleRequestClose, handleClick, userid, } = this.props;
        return (
            <Menu id="long-menu"
                anchorEl={anchorEl}
                open={menuState}
                onClose={handleRequestClose}
                style={{ maxHeight: ITEM_HEIGHT * 4.5 }}
                MenuListProps={{
                    style: {
                        width: 150,
                        paddingTop: 0,
                        paddingBottom: 0
                    },
                }}>
                {options.map(option =>
                    <MenuItem key={option.id} onClick={handleClick.bind(this, option.id, this.props.userid)}>
                        {option.name}
                    </MenuItem>,
                )}
            </Menu>
        );
    }

}

const columnData = [
    { id: 'id', numeric: false, disablePadding: false, label: 'S.No.', isAdminOnly: false },
    { id: 'userId', numeric: false, disablePadding: true, label: 'User Id', isAdminOnly: false },
    { id: 'userName', numeric: false, disablePadding: true, label: 'User Name', isAdminOnly: false },
    { id: 'emailId', numeric: false, disablePadding: true, label: 'Email', isAdminOnly: false },
    { id: 'userStatus', numeric: false, disablePadding: true, label: 'Account Status', isAdminOnly: false },
    { id: 'operation', numeric: false, disablePadding: true, label: 'Operation', isAdminOnly: false },
    { id: 'action', numeric: false, disablePadding: true, label: 'Actions' },
];

class DataTableHead extends React.Component {
    static propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { order, orderBy, numSelected, rowCount, loggedinUserRole_id } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {columnData.map(column => {
                        return (
                            (column.isAdminOnly && loggedinUserRole_id != "2") ? null :
                                <TableCell
                                    key={column.id}
                                    numeric={column.numeric}
                                    padding={column.disablePadding ? 'none' : 'checkbox'}
                                >
                                    <Tooltip
                                        title="Sort"
                                        placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                        enterDelay={300}
                                    >
                                        <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={order}
                                            onClick={this.createSortHandler(column.id)}
                                        >
                                            {column.label}
                                        </TableSortLabel>
                                    </Tooltip>
                                </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

class DataTable extends React.Component {
    handleRequestSort = (event, property) => {
        // console.log('sort property',property)
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        // console.log('this.state.data',this.state.data)

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({ data, order, orderBy });
    };
    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    onOptionMenuSelect = (data, event) => {
        this.state.user = data;
        this.setState({ user: data, menuState: true, anchorEl: event.currentTarget });
    };
    handleRequestClose = () => {
        this.setState({ menuState: false });
    };
    handleClick(click_id, userid, e) {
        // console.log('handleClick', click_id, "userid", userid);
        if (click_id == 1) {
            this.props.history.push('/user/approve/' + userid);
        }
        this.setState({ menuState: false });
    };
    closeDialog = (data) => {
        this.setState({ openDialog: false });
    }
    constructor(props, context) {
        super(props, context);

        this.state = {
            anchorEl: undefined,
            menuState: false,
            openDialog: false,
            order: 'asc',
            orderBy: 'calories',
            data: [],
            page: 0,
            rowsPerPage: 20,
            user: null,
        };
    }

    render() {
        const { filterText } = this.props
        const { menuState, anchorEl, data, order, orderBy, selected, rowsPerPage, page } = this.state;
        this.state.data = this.props.data
        // console.log('DataTable', this.state.data)
        return (
            <Paper>
                <div className="flex-auto">
                    <div className="table-responsive-material">
                        <Table className="">
                            <DataTableHead
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={this.handleRequestSort}
                                rowCount={this.state.data ? this.state.data.length : 0}
                                loggedinUserRole_id={this.props.loggedinUserRole_id}
                            />
                            <TableBody>
                                {/* {console.log('data', this.state.data)} */}
                                {!this.state.data ?
                                    <TableRow>
                                        <TableCell colSpan={7}/>
                                    </TableRow>
                                    :
                                    this.state.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((n, index) => {
                                        return (
                                            (!filterText) || (filterText.length > 0 &&
                                                ((n.userId && n.userId.toLowerCase().indexOf(filterText) >= 0)
                                                    || (n.userName && n.userName.toLowerCase().indexOf(filterText) >= 0)
                                                    || (n.emailId && n.emailId.toLowerCase().indexOf(filterText) >= 0)
                                                    // || (n.issue && n.issue.toLowerCase().indexOf(filterText) >= 0)
                                                    // || (n.grantt && n.grantt.toLowerCase().indexOf(filterText) >= 0)
                                                    || (n.userStatus && n.userStatus.toLowerCase().indexOf(filterText) >= 0))) ?
                                                <TableRow
                                                    hover
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={n.id}
                                                >
                                                    <TableCell padding="checkbox">{(index + 1) + (page * rowsPerPage)}</TableCell>
                                                    <TableCell padding="none">{n.userId}</TableCell>
                                                    <TableCell padding="none">{n.userName}</TableCell>
                                                    <TableCell padding="none">{n.emailId}</TableCell>
                                                    <TableCell padding="none">{n.userStatus}</TableCell>
                                                    <TableCell padding="none">{n.operation}</TableCell>
                                                    <TableCell padding="none">
                                                        <IconButton aria-label="view" onClick={this.onOptionMenuSelect.bind(this, n)}>
                                                            <i className="zmdi zmdi-more-vert"></i>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                                : null
                                        );
                                    })}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        count={this.state.data ? this.state.data.length : 0}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        rowsPerPageOptions={[5, 20, 40, 100]}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                        <CardMenu menuState={menuState} anchorEl={anchorEl} handleClick={this.handleClick.bind(this)}
                            handleRequestClose={this.handleRequestClose.bind(this)} userid={this.state.user ? this.state.user.id : null}
                            loggedinUserRole_id={this.props.loggedinUserRole_id} />
                    </div>
                </div>
            </Paper>
        );
    }
}

function mapStateToProps(state) {
    return state;
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(userdetails, dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DataTable));


// WEBPACK FOOTER //
// ./app/userdetails/pendingapproval/datatable.js